<template>
<v-icon color="green darken-2" class="mr-2" @click='generate'>
  mdi-printer-outline
</v-icon>
</template>

<script>
import pdfMake from "pdfmake-rtl/build/pdfmake";
import pdfFonts from "../assets/fonts/base64/fonts";
import retrievePackageLabelData from '../functions/retrievePackageLabelData';

pdfMake.vfs = pdfFonts.vfs;
pdfMake.fonts = pdfFonts.fonts;

export default {
  name: "PackageLabel",
  props: {
    person_mid: {
      required: true
    }
  },
  methods: {
    async generate() {
      const info = await retrievePackageLabelData(this.person_mid);
      if (!info) return

      const receiverName = await this.getReceiverName(info);
      const receiverAddress = info.address || "-"
      const receiverZipcode = info.zip_code || "-"

      const doc = {
        pageSize: "A5",

        pageMargins: [15, 20, 15, 20],

        // defaultStyle: {
        //   font: "Yekan",
        //   fontSize: 12,
        //   alignment: "right",
        // },
        content: [
          // جدول اطلاعات
          {
            style: "box",
            table: {
              widths: ["auto", "*"],
              dontBreakRows: true,
              defaultAlignment: "right",
              body: [
                [{
                    text: "گیرنده:",
                    style: "title",
                    font: "Titr"
                  },
                  {
                    text: receiverName,
                    style: "value",
                    noWrap: false
                  },
                ],
                [{
                    text: "آدرس:",
                    style: "title",
                    font: "Titr"
                  },
                  {
                    text: receiverAddress,
                    style: "value",
                    noWrap: false
                  },
                ],
                [{
                    text: "کدپستی:",
                    style: "title",
                    font: "Titr"
                  },
                  {
                    text: receiverZipcode,
                    style: "value",
                    noWrap: false
                  },
                ],
                [{
                    text: "فرستنده:",
                    style: "title",
                    font: "Titr"
                  },
                  {
                    text: ")09366877798()051-33641986( قاسمی",
                    style: "value",
                    noWrap: false
                  },
                ],
                [{
                    text: "آدرس:",
                    style: "title",
                    font: "Titr"
                  },
                  {
                    text: `مشهد-  بازار رضا پلاک 2/605`,
                    style: "value",
                    noWrap: false
                  },
                ],
                [{
                    text: "کد ملی:",
                    style: "title",
                    font: "Titr"
                  },
                  {
                    text: `0936941367`,
                    style: "value",
                    noWrap: false
                  },
                ],
              ]
            },

            layout: {
              hLineWidth: () => 0,
              vLineWidth: () => 0,
              paddingLeft: () => 6,
              paddingRight: () => 6,
              paddingTop: () => 6,
              paddingBottom: () => 6,
            }
          },

          // FOOTER
          // {
          //   text: "سامانه ارسال -  نسخه چاپ بسته".split(" ").reverse().join(" "),
          //   alignment: "center",
          //   margin: [0, 20, 0, 0],
          //   fontSize: 8,
          //   color: "#666"
          // }
        ],
        styles: {
          title: {
            font: "Titr",
            fontSize: 14,
            margin: [0, 0, 5, 5],
            alignment: "right"
          },
          value: {
            font: "Yekan",
            fontSize: 12,
            color: "#444",
            margin: [0, 0, 0, 5],
            alignment: "right",
            // rtl: true
          },
          box: {
            margin: [0, 10, 0, 10],
            // fillColor: "#f9f9f9",
            borderRadius: 8
          }
        }
      };

      pdfMake.createPdf(doc).open();
    },

    async getReceiverName(info) {

      const toPersianDigits = s => s.replace(/\d/g, d => "۰۱۲۳۴۵۶۷۸۹" [d]);

      let title = info.name || "";

      if (info.mobile) {
        const mobile = toPersianDigits(info.mobile).split("").reverse().join("");
        title += " (" + mobile + ")";
      }

      if (info.gender === true) title = `آقای ${title}`;
      else if (info.gender === false) title = `خانم ${title}`;

      return title
    },

  }
};
</script>


// content: [
//   // --- جدول گیرنده ---
//   {
//     style: "box",
//     table: {
//       widths: ["*", "auto"],
//       dontBreakRows: true,
//       defaultAlignment: "right",
//       body: [
//         [{
//             text: "گیرنده:",
//             style: "title",
//             font: "Titr"
//           },
//           {
//             text: receiverName,
//             style: "value",
//             noWrap: false
//           },
//         ],
//         [{
//             text: "آدرس:",
//             style: "title",
//             font: "Titr"
//           },
//           {
//             text: receiverAddress,
//             style: "value",
//             noWrap: false
//           },
//         ],
//         [{
//             text: "کدپستی:",
//             style: "title",
//             font: "Titr"
//           },
//           {
//             text: receiverZipcode,
//             style: "value",
//             noWrap: false
//           },
//         ],
//       ]
//     },
//     layout: {
//       hLineWidth: () => 0,
//       vLineWidth: () => 0,
//       paddingLeft: () => 6,
//       paddingRight: () => 6,
//       paddingTop: () => 6,
//       paddingBottom: () => 6,
//     }
//   },
//   // --- خط جداکننده ---
//   {
//     canvas: [{
//       type: 'line',
//       x1: 0,
//       y1: 0,
//       x2: 390,
//       y2: 0,
//       lineWidth: 1.2,
//       lineColor: '#777',
//       dash: {
//         length: 4,
//         space: 3
//       }
//     }],
//     // layout: 'noBorders',
//     margin: [0, 12, 0, 12]
//   },
//   // --- جدول فرستنده ---
//   {
//     style: "box",
//     table: {
//       widths: ["*", "auto"],
//       dontBreakRows: true,
//       defaultAlignment: "right",
//       body: [
//         [{
//             text: "فرستنده:",
//             style: "title",
//             font: "Titr"
//           },
//           {
//             text: ")09109159233()0513364186( قاسمی",
//             style: "value",
//             noWrap: false
//           },
//         ],
//         [{
//             text: "آدرس:",
//             style: "title",
//             font: "Titr"
//           },
//           {
//             text: `مشهد-  بازار رضا پلاک 2/605`,
//             style: "value",
//             noWrap: false
//           },
//         ],
//         [{
//             text: "کد ملی:",
//             style: "title",
//             font: "Titr"
//           },
//           {
//             text: `0936941367`,
//             style: "value",
//             noWrap: false
//           },
//         ],
//       ]
//     },
//     layout: {
//       hLineWidth: () => 0,
//       vLineWidth: () => 0,
//       paddingLeft: () => 6,
//       paddingRight: () => 6,
//       paddingTop: () => 6,
//       paddingBottom: () => 6,
//     }
//   }
// ],
